import { useFlag } from 'api/feature-flags/provider';
import React from 'react';

export default function ConsentDashboardFeatureFlagGuard(props: React.PropsWithChildren) {
  const { children } = props;

  const isInternalUser = useFlag('role.internalUser');
  const hasAccessToConsentDashboard = useFlag('feature.consentDashboard');

  if (!shouldShowConsentDashboard(hasAccessToConsentDashboard, isInternalUser)) return null;

  return <>{children}</>;
}

function shouldShowConsentDashboard(hasAccessToConsentDashboard: boolean, isInternalUser: boolean) {
  if (hasAccessToConsentDashboard) return true;
  if (isInternalUser && window.localStorage.getItem('showInternalTools') === 'true') {
    return true;
  }

  return false;
}
